import React from 'react';

import TableCol from './column';

const TableCols = ({ columns }) => {
  return (
    <div className='table-cols'>
      {columns.map((item, index) => {
        const { value, ...rest } = item;

        return (
          <TableCol
            key={index}
            {...rest}
          >
            {value}
          </TableCol>
        )
      })}
    </div>
  )
}

export default TableCols;
